import { memo } from 'react';

import {
  CellPrimaryText,
  CellSecondaryText,
  CellWithLabel,
  ProgressBarCell,
  ProgressBarFill,
  ProgressBarLabel,
  ProgressBarTrack,
} from './GeneratikTable.styles';

export { CurrencyCell, DateCell, NumberCell, StatusCell, TextCell } from '@/shared/ui';
export type {
  CurrencyCellProps,
  DateCellProps,
  NumberCellProps,
  StatusCellProps,
  TextCellProps,
} from '@/shared/ui';

export interface CellWithLabelProps {
  primary: string;
  secondary?: string;
}

export const CellWithLabelRenderer = memo(({ primary, secondary }: CellWithLabelProps) => (
  <CellWithLabel>
    <CellPrimaryText>{primary}</CellPrimaryText>
    {secondary && <CellSecondaryText>{secondary}</CellSecondaryText>}
  </CellWithLabel>
));
CellWithLabelRenderer.displayName = 'CellWithLabelRenderer';

export interface ProgressBarProps {
  value: number;
  label?: string;
  color?: string;
}

export const ProgressBarRenderer = memo(({ value, label, color }: ProgressBarProps) => (
  <ProgressBarCell>
    <ProgressBarTrack>
      <ProgressBarFill value={value} barcolor={color} />
    </ProgressBarTrack>
    {label && <ProgressBarLabel>{label}</ProgressBarLabel>}
  </ProgressBarCell>
));
ProgressBarRenderer.displayName = 'ProgressBarRenderer';
